import React, { useState } from 'react';
import { getAuth, createUserWithEmailAndPassword, sendEmailVerification } from 'firebase/auth';
import { Link } from 'react-router-dom';
import './FormStyles.css';

export default function Signup() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [emailSent, setEmailSent] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const auth = getAuth();
        try {
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            sendEmailVerification(userCredential.user)
                .then(() => {
                    setEmailSent(true);
                })
                .catch((error) => {
                    console.error(error);
                });
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div>
            {!emailSent ? (
                <form className="form-container" onSubmit={handleSubmit}>
                    <input className="form-input" type="email" placeholder="Email" onChange={(e) => setEmail(e.target.value)} />
                    <input className="form-input" type="password" placeholder="Password" onChange={(e) => setPassword(e.target.value)} />
                    <button className="form-button" type="submit">Sign Up</button>
                    <p>Already have an account? <Link to="/signin">Sign In</Link></p>
                </form>
            ) : (
                <div className="email-verification-message">
                    Email verification sent. Please check your email to verify your account.
                </div>
            )}
        </div>
    );
}
